import React, { memo, useState } from 'react'
import { isEqual } from 'lodash'

import { CardType } from 'types/deck'
import { DOUBLE_FACED_LAYOUTS } from 'types/card'

import { useCanEditDeck } from 'redux/deck/selectors'

import SaveService from 'services/save.service'

import Icon from 'components/elements/Icon'
import Link from 'components/elements/Link'
import BasicCard from 'components/card/BasicCard'
import ArchidektDropdown from 'components/elements/ArchidektDropdown'

import styles from './tokenCardWrapper.module.scss'

type Props = {
  card: CardType
  generatedBy: string[]
}

const TokenCardWrapper = memo(
  ({ card, generatedBy }: Props) => {
    const canEditDeck = useCanEditDeck()

    const [flipped, setFlipped] = useState(card.flippedDefault)

    const handleAddCard = () => SaveService.save({ ...card, qty: 1, categories: ['Tokens & Extras'] })
    const handleRemoveCard = () => SaveService.save([], card.id)

    return (
      <div className={styles.container}>
        <Link href={`/card?name=${card.name}&uid=${card.uid}`} target="_blank" className={styles.link}>
          <BasicCard flipped={flipped} className={`${styles.card} ${flipped ? styles.flipped : ''}`} card={card} />
        </Link>
        {canEditDeck && (
          <div className={styles.controls}>
            <button disabled={card.qty > 0} className={`${styles.button} ${styles.green}`} onClick={handleAddCard}>
              <Icon name="plus" />
            </button>
            <span className={styles.buttonContainer}>
              <button
                className={`
                   ${styles.quantity}
                   ${styles.button}
                   ${card.qty > 0 || card.otherPrintingQty > 0 ? styles.hasQuantity : ''}
               `}
                disabled>
                {card.qty}
              </button>
              {card.otherPrintingQty > 0 && (
                <span tabIndex={0} className={styles.hasOtherPrintingQuantity}>
                  +{card.otherPrintingQty}
                </span>
              )}
            </span>

            <span className={styles.buttonContainer}>
              <button className={`${styles.button} ${styles.red}`} disabled={!card.qty} onClick={handleRemoveCard}>
                <Icon name="minus" />
              </button>
            </span>

            <ArchidektDropdown
              triggerClassName={styles.dropdownIcon}
              menuClassName={styles.dropdown}
              options={[
                {
                  label: 'Generated by',
                  type: 'header',
                },
                ...generatedBy.map(cardName => ({
                  label: <div className={styles.generatedBy}>{cardName}</div>,
                })),
              ]}>
              <button className={`${styles.button} ${styles.blue}`}>
                <Icon name="question" />
              </button>
            </ArchidektDropdown>
          </div>
        )}

        {DOUBLE_FACED_LAYOUTS.includes(card.layout) && (
          <button
            className={`${styles.button} ${styles.flipButton} ${flipped && styles.flipped}`}
            onClick={() => setFlipped(!flipped)}>
            <Icon name="refresh" />
          </button>
        )}
      </div>
    )
  },
  (prevProps: Props, nextProps: Props) => {
    // Only ever rerender this component if and only if the card has changed
    return isEqual(prevProps.card, nextProps.card)
  },
)

export default TokenCardWrapper
